import { environment } from '@lla-platform/core/core-util'

export const CALL_INTELLIGENCE_API_URL = {
  dashboard: `${environment.apiUrl}/call-intelligence/dashboard`,
  drilldown: `${environment.apiUrl}/call-intelligence/drilldown`,
  drilldownExport: `${environment.apiUrl}/call-intelligence/drilldown/export`,
  leadsList: `${environment.apiUrl}/call-intelligence/filters/leads`,
  exportLeadsList: `${environment.apiUrl}/call-intelligence/filters/leads/export`,
  leadDetails: (id: string) => `${environment.apiUrl}/call-intelligence/leads/${id}/details`,
  linkContact: (leadId: string, contactId: string) =>
    `${environment.apiUrl}/call-intelligence/leads/${leadId}/link-contact/${contactId}`,
  unlinkContact: (leadId: string) =>
    `${environment.apiUrl}/call-intelligence/leads/${leadId}/unlink-contact`,
  markReviewed: (id: string) => `${environment.apiUrl}/call-intelligence/leads/${id}/reviewed`,
  reProcessLead: (id: string) => `${environment.apiUrl}/call-intelligence/leads/${id}/reprocess`,
  activeTags: `${environment.apiUrl}/call-intelligence/tags`,
  callTags: `${environment.apiUrl}/call-tags`,
  callTagsFilters: `${environment.apiUrl}/call-tags/filters`,
  callTag: (id: string) => `${environment.apiUrl}/call-tags/${id}`,
  retagCalls: `${environment.apiUrl}/call-tags/retag`,
  searchContacts: `${environment.apiUrl}/contacts/filters`,
  updateLeadsAnalysis: (id: string) => `${environment.apiUrl}/call-intelligence/leads/${id}/analysis`,
  getLeadsAnalysisVersions: (id: string) =>
    `${environment.apiUrl}/call-intelligence/leads/${id}/analysis/versions`
}
